
export const zonesLayer = {
    //id: 'zones-fill',
    type: 'fill',
    paint: {
      'fill-color': '#e3e327',
      'fill-opacity': 0.0
    }
  };
export const zonesPrelimLayer = {
    //id: 'zones-fill',
    type: 'fill',
    paint: {
      'fill-color': '#e3e327',
      'fill-opacity': 0.0
    }
  };
export const fieldsLayer = {
    id: 'field-fill',
    type: 'fill',
    paint: {
      'fill-color': '#e3e327',
      'fill-opacity': 0.0
    }
  };
  
  export const fieldsBorderLayer = {
    id: 'field-border',
    type: 'line',
    paint: {
      'line-color': '#f1f1f1',
      'line-width': 2
    }
  };
  export const fieldsBorderLayerSelected = {
    id: 'field-border-selected',
    type: 'line',
    paint: {
      'line-color': '#f1f1f1',
      'line-width': 8
    }
  };
  export const zonesBorderLayer = {
    //id: 'zones-border',
    type: 'line',
  };

  export const zonesBorderLayerEdit = {
    //id: 'zones-border',
    type: 'line',
    paint: {
      'line-color': '#000',
      'line-width': 2
    }
  };

  export const zonesPrelimBorderLayer = {
    //id: 'zones-border',
    type: 'line',
    paint: {
      'line-color': '#000',
      'line-width': 2
    }
  };

  export const fieldsBorderLayerAlt = {
    id: 'field-border',
    type: 'line',
    paint: {
      'line-color': '#fff', //'#0CCDA2',
      'line-width': 2
    }
  };
  
  export const fieldsHighlightLayer = {
    id: 'fields-highlighted',
    type: 'line',
    paint: {
      'line-color': '#FF0000',
      'line-width': 5
    }
  };
  
  export const fieldsSelectedBorderLayer = {
    id: 'fields-seected-border',
    type: 'line',
    paint: {
      'line-color': '#f1f1f1',
      'line-width': ['interpolate', ['linear'], ['zoom'], 5, 2, 15, 6]
    }
  };

  export const fieldsSelectedBorderLayerAlt = {
    id: 'fields-seected-border',
    type: 'line',
    paint: {
      'line-color': '#fff', //'#0CCDA2',
      'line-width': ['interpolate', ['linear'], ['zoom'], 5, 2, 15, 6]
    }
  };

  export const fieldSymbolLayer = {
      id: "fields-name-label",
      type: "symbol",
      layout: {
        "text-field": ["get", "name"],
        "text-size": 24,
        'text-font': ['Open Sans Bold'],
      },
      paint: {
        "text-color": "#ffff00",
        "text-halo-color": "#333333",
        "text-halo-width": 1,
      }
  }
  

  // edit styles
  export const editFieldsLayerFragments = {
    id: 'edit-field-fill-fragment',
    type: 'fill',
    'paint': {
      'fill-color': '#ffffff',
      'fill-opacity': 0.2
    }
  };

  export const editFieldsLayer = {
    id: 'edit-field-fill',
    type: 'fill',
    'paint': {
      'fill-color': 'rgb(211, 2015, 205)',
      'fill-opacity': 0.2
    }
  };

  export const editFieldsBorderLayerFragments = {
    id: 'edit-field-border-fragment',
    type: 'line',
    paint: {
      'line-color': '#007bff',
      'line-width': 2
    }
  };
  
  export const editFieldsBorderLayer = {
    id: 'edit-field-border',
    type: 'line',
    paint: {
      'line-color': 'rgb(211, 132, 8)',
      'line-width': 2
    }
  };

    // import styles
    export const importFieldsLayer = {
      id: 'import-field-fill',
      type: 'fill',
      'paint': {
        'fill-color': 'rgb(211, 201, 205)',
        'fill-opacity': 0.2
      }
    };
    
    export const importFieldsBorderLayer = {
      id: 'import-field-border',
      type: 'line',
      paint: {
        'line-color': 'rgb(211, 132, 8)',
        'line-width': 2
      }
    };

  // regrid parcels styles
  export const parcelsBorderLayer = {
    id: 'parcel-border',
    source: "parcel-vector-tiles",
    "source-layer": "parcels",
    type: 'line',
    paint: {
      'line-color': '#dd3b3b',
      'line-width': [
        'interpolate',
        ['linear'],
        ['zoom'],
        12, 1, 15, 4
      ]
    }
  };

  export const parcelFillLayer = {
    id: 'parcel-fill',
    source: "parcel-vector-tiles",
    "source-layer": "parcels",
    type: 'fill',
    'paint': {
      'fill-color': '#FFFFFF',
      'fill-opacity': 0
    }
  };

  export const parcelSelectedLayer = {
    id: 'parcel-selected-fill',
    source: "parcel-vector-tiles",
    "source-layer": "parcels",
    type: 'fill',
    'paint': {
      'fill-color': '#c0c236',
      'fill-opacity': 0.4
    }
  };

  export const clusterLayer = {
    id: 'field-cluster',
    type: 'circle',
    filter: ['has', 'point_count'],
    paint: {
      'circle-color': ['step', ['get', 'point_count'],  '#fff' /*'#0CCDA2'*/, 100, '#f1f075', 750, '#f28cb1'],
      'circle-radius': ['step', ['get', 'point_count'], 20, 100, 30, 750, 40],
      'circle-stroke-width': 1,
      'circle-stroke-color': '#ffffff'

    }
  };

  export const unclusteredLayer = {
    id: 'field-unclustered-point',
    type: 'circle',
    filter: ['!', ['has', 'point_count']],
    paint: {
      'circle-color': '#fff', //'#0CCDA2',
      'circle-radius': 5,
      'circle-stroke-width': 1,
      'circle-stroke-color': '#fff'
    }
  };

